export default {
  'priceEditor.title': '菜品',

  'priceEditor.column.category': '分类',
  'priceEditor.column.name': '菜品',
  'priceEditor.column.foreign_name': '菜品中文名',
  'priceEditor.column.price': '价格',
  'priceEditor.column.member_price': '会员价',
  'priceEditor.column.original_price': '原价',
  'priceEditor.column.new_price': '新价',
  'priceEditor.column.new_member_price': '新会员价',
  'priceEditor.column.updated_at': '更新时间',
  'priceEditor.column.note': '备注',
  'priceEditor.column.price.tooltip': 'Chowbus有规定每周编辑菜品价格的次数上限，如有需求请联系您的客服经理。',

  'priceEditor.drawer.title': '价格调整',
  'priceEditor.limit.underPromotion': '此菜品正在促销中',
  'priceEditor.limit.reachLimit': '您已达到当前周期内编辑价格次数上限',
  'priceEditor.limit.blocked': '禁止进行价格调整',
  'priceEditor.limit.setupLimitationFirst': '禁止进行价格调整-未添加价格调整限制,如果需要请先设置',

  'priceEditor.price.edited': '已编辑',
  'priceEditor.pending': '价格正在审核',
  'priceEditor.isOpenPriced': '开价菜',
  'priceEditor.weightUnitDesc': '每{unit}',
  'priceEditor.drawer.price.required': '价格不能为空',
  'priceEditor.updatePrompt': '确认要保存此修改吗？',
  'priceEditor.updateSuccess.tip': '成功更新{count}个菜品',
  'priceEditor.drawer.pointprice.required': '积分价格不能为空',
  'priceEditor.pointprice.update.error.tip': '积分价格不能为空或0',

  'priceEditor.noChanged': '无任何修改',
  'priceEditor.updatedThisWeek': '本周已更新',
  'priceEditor.itemCount': '{count}件商品',

  'priceEdit.action.addDish': '新建菜品',
  'priceEdit.action.copyDish': '复制菜品',
  'priceEdit.action.updateMultiple': '批量更新',
  'priceEdit.action.updatePrice': '菜品价格',
  'priceEdit.action.updateMemberPrice': '菜品会员价格',
  'priceEdit.action.showMemberPrice': '显示会员价格',
  'priceEdit.action.hideMemberPrice': '隐藏会员价格',
  'priceEdit.action.showPointPrice': '显示积分价格',
  'priceEdit.action.hidePointPrice': '隐藏积分价格',

  'priceEdit.noRecord': '无匹配记录',

  'batchPriceEdit.title': '更新多个菜品价格',
  'batchMemberPriceEdit.title': '更新多个菜品会员价格',
  'batchPriceEdit.typeOfChange': '变更方式',
  'batchPriceEdit.increase_percentage': '增加%',
  'batchPriceEdit.decrease_percentage': '减少%',
  'batchPriceEdit.increase_dollar': '增加$',
  'batchPriceEdit.decrease_dollar': '减少$',
  'batchPriceEdit.operation_guidance': '在菜单中选择要更新的菜品。 单击“预览”以查看新价；点击“应用”以保存价格更新。',
  'batchMemberPriceEdit.operation_guidance':
    '在菜单中选择要更新的菜品。 单击“预览”以查看新会员价；点击“应用”以保存会员价更新。',
  'batchPriceEdit.guidance': '这会使{dishCount}道所选菜品价格{actionType}{amount}。',
  'batchMemberPriceEdit.guidance': '这会使{dishCount}道所选菜品会员价{actionType}{amount}',
  'batchPriceEdit.selectedSummary': '已选{dishCount}个菜品',
  'batchPriceEdit.amount': '数量',
  'batchPriceEdit.action.preview': '预览',
  'batchPriceEdit.action.applyChange': '应用价格变化到{dishCount}个所选菜品',
  'batchPriceEdit.search.placeholder': '筛选菜品',
  'batchPriceEdit.number.error': '[错误] 请输入小于{limit}的数字',
  'bulkTaxExempt.title': '税设置',
  'bulkTaxExempt.guidance': '在菜单中选择要更新的菜品。 点击“应用”以保存更新。',
  'bulkTaxExempt.description': '将选中菜品设置为“免税”',
  'bulkDiscountExempt.title': '折扣设置',
  'bulkDiscountExempt.description': '所选菜品在订单中免于折扣计算',
  discountExemptTips: '*已设为免于折扣计算',
  taxExemptTips: '*已设为免税',

  'dishes.delete.title': '删除菜品',
  'dishes.delete.copy':
    '此操作将从所有关联菜单中<i>永久</i>删除这道菜。如果您只是想在菜单上隐藏菜品，请使用菜单管理下的菜单设置。',
  'dishes.delete.prompt': '确认要删除此菜品吗？',
  'dishes.delete.confirm': '确认删除',
  'dishes.delete.succeed': '成功删除{count}个菜品',

  'priceEditor.column.point_price': '积分价',
};
